module.exports = __webpack_public_path__ + "img/presentation05.088e09ad.jpg";